import { Box, Typography } from '@mui/material';
import React, { useState } from 'react';
import type { LocalBookItem, LocalSectionItem } from '../types';
import { BookListRow } from './BookListRow';
import clsx from 'clsx';

interface Props {
  item: LocalSectionItem;
  seq: number;
  onClickRow?: (event: React.MouseEvent, item: LocalBookItem) => void;
}

export function SectionListRow(props: Props) {
  const { item, seq, onClickRow } = props;
  const { title, books } = item;
  const [lastSelectedId, setLastSelectedId] = useState<string | number>();

  const handleClickRow = (item: LocalBookItem) => (event: React.MouseEvent) => {
    onClickRow?.(event, item);
  };

  return (
    <Box className="SectionListRow-root" sx={{ mb: 8 }}>
      <Typography variant="h5" sx={{ pl: 0, color: '#26282A' }}>
        {seq}. {title}
      </Typography>
      <Box
        sx={{
          '& .BookListRow-root': {
            mt: 2,
          },
          '& .BookListRow-highlight': {
            color: 'red',
          },
        }}
      >
        {books.map((book, i) => (
          <BookListRow
            key={book.bookId}
            item={book}
            sectionSeq={seq}
            seq={i + 1}
            className={clsx({
              'BookListRow-highlight': book.bookId === lastSelectedId,
            })}
            onClickRow={handleClickRow(book)}
          />
        ))}
      </Box>
    </Box>
  );
}
